<div class="channels-list" #channelList>
  <div
    class="channels-list__section list-all"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="$safeNavigationMigration(chat().channelsFilter?.size)"
    [infiniteScrollContainer]="'.list-all'"
    (scrolled)="onScroll()"
    [fromRoot]="true">
    @if (!ui().isLoadingChannels) { @for (channel of channels(); track channel.uid) {
    <ngx-channels-list-item
      [active]="channel?.uid === chat().selectedChannel?.uid"
      [channel]="channel"
      (click)="selectChannel(channel)">
    </ngx-channels-list-item>
    } @empty {
    <div class="chat-empty-container">
      <h1 class="chat-empty-container-title">{{ 'NGX-MESSAGING.CHANNELS.noConversationsHere' | translate }}</h1>
    </div>
    } } @else {
    <div class="skeleton-items">
      <ngx-skeleton-loader
        animation="false"
        [count]="10"
        appearance="line"
        [theme]="{
          'border-radius': '5px',
          height: '80px'
        }"></ngx-skeleton-loader>
    </div>
    }
  </div>
</div>
